import styled from 'styled-components';
import { Link as ReactRouterLink, NavLink as ReactRouterNavLink } from 'react-router-dom';

export const Link = styled(ReactRouterLink)`
  &.pageFooter {
    text-decoration: none;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
      text-decoration: none;
    }

    color: #444444;
    font-size: 1.125rem;
  }
`;

export const NavLink = styled(ReactRouterNavLink)`
  &.leftNavMenu {
    text-decoration: none;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
      text-decoration: none;
    }

    color: #444444;
    font-size: 1.2rem;

    &.active {
      font-weight: 600;
    }
  }
`;
